// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___1duJ2","containerTitle":"style__containerTitle___2uNim","containerSubtitle":"style__containerSubtitle___mVIp_"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/carousel/basic/last/style.css
// module id = 1452
// module chunks = 0